import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../contexts/AuthContext';
import { Form, FormGroup, Input, Label, Col, Button, Row, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { handleResponse } from '../utils/handlers';

import styles from './UserSettings.module.css';

function UserSettings(props) {

    let { authenticatedUser, refreshUserInfo } = useContext(AuthContext);

    const [defaultDepot, setDefaultDepot] = useState(authenticatedUser?.fmeUserInfo?.defaultDepot?.code || '');
    const [depots, setDepots] = useState(null);
    const [defaultDepotPrinter, setDefaultDepotPrinter] = useState(authenticatedUser?.fmeUserInfo?.defaultDepotPrinter?.id || '');
    const [defaultDepotPlainPaperPrinter, setDefaultDepotPlainPaperPrinter] = useState(authenticatedUser?.fmeUserInfo?.defaultDepotPlainPaperPrinter?.id || '');
    const [defaultDepotLabelPrinter, setDefaultDepotLabelPrinter] = useState(authenticatedUser?.fmeUserInfo?.defaultDepotLabelPrinter?.id || '');
    const [depotPrinters, setDepotPrinters] = useState(null);
    const [busy, setBusy] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setBusy(true);
        fetch(`api/depot/select-list`, { credentials: 'include' })
            .then(handleResponse)
            .then(data => {
                setDepots(data);
                setBusy(false);
            })
            .catch(error => console.log(error));
    }, []);

    useEffect(() => {
        //setBusy(true);
        if (defaultDepot) {
            fetch(`api/depot/${defaultDepot}/printers`, { credentials: 'include' })
                .then(handleResponse)
                .then(data => {
                    var depotPrinters = data;
                    setDepotPrinters(depotPrinters);
                    //setBusy(false);
                })
                .catch(error => console.log(error));
        }
    }, [defaultDepot]);

    useEffect(() => {

        if (!depotPrinters)
            return;

        if (depotPrinters?.map(dp => dp.id)?.includes(defaultDepotPrinter))
            return;

        if (depotPrinters.length > 0) {
            setDefaultDepotPrinter(depotPrinters[0].id);
            setDefaultDepotPlainPaperPrinter(depotPrinters[0].id);
            setDefaultDepotLabelPrinter(depotPrinters[0].id);
        }
        else {
            setDefaultDepotPrinter('');
            setDefaultDepotPlainPaperPrinter('');
            setDefaultDepotLabelPrinter('');
        }

    }, [depotPrinters, defaultDepotPrinter]);

    function handleDefaultDepotPrinterChange(event) {
        var selectedDepotPrinter = parseInt(event.target.value);

        if (!isNaN(selectedDepotPrinter)) {
            setDefaultDepotPrinter(selectedDepotPrinter);
        }
    }

    function handleDefaultDepotPlainPaperPrinterChange(event) {
        var selectedDepotPrinter = parseInt(event.target.value);

        if (!isNaN(selectedDepotPrinter)) {
            setDefaultDepotPlainPaperPrinter(selectedDepotPrinter);
        }
    }

    function handleDefaultDepotLabelPrinterChange(event) {
        var selectedDepotPrinter = parseInt(event.target.value);

        if (!isNaN(selectedDepotPrinter)) {
            setDefaultDepotLabelPrinter(selectedDepotPrinter);
        }
    }

    var saveSettings = (e) => {
        setIsSaving(true);

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        fetch(`api/user/settings`, {
            credentials: 'include',
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                defaultDepot: defaultDepot,
                defaultDepotPrinter: defaultDepotPrinter,
                defaultDepotPlainPaperPrinter: defaultDepotPlainPaperPrinter,
                defaultDepotLabelPrinter: defaultDepotLabelPrinter
            })})
            .then(data => {
                setIsSaving(false);
                refreshUserInfo();
            })
            .catch(error => {
                console.log(error);
                setIsSaving(false);
            })
    }

    return busy ? <BusyIndicator isBusy={busy} /> : (
        depots &&
        <React.Fragment>
            <Form className={styles.userSettings} onSubmit={null}>
                <fieldset disabled>
                    <FormGroup row>
                        <Label sm={3} xs={5}>Name</Label>
                        <Col sm={9} xs={7}><Input type="text" value={authenticatedUser.given_name} readOnly/></Col>
                    </FormGroup>
                </fieldset>
                <fieldset>
                    <FormGroup row>
                        <Label sm={3} xs={5}>Default Depot</Label>
                        <Col sm={9} xs={7}>
                            <Input type="select" value={defaultDepot} onChange={e => setDefaultDepot(e.target.value)}>
                                {depots.map((d, index) => <option key={`d${index}`} value={d.code}>{d.description}</option>)}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={3} xs={5}>Overprint Printer</Label>
                        <Col sm={9} xs={7}>
                            <Input type="select" value={defaultDepotPrinter} onChange={handleDefaultDepotPrinterChange}>
                                {depotPrinters?.map((p, index) => <option key={`p${index}`} value={p.id}>{p.printerName}</option>)}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={3} xs={5}>Plain Paper Printer</Label>
                        <Col sm={9} xs={7}>
                            <Input type="select" value={defaultDepotPlainPaperPrinter} onChange={handleDefaultDepotPlainPaperPrinterChange}>
                                {depotPrinters?.map((p, index) => <option key={`p${index}`} value={p.id}>{p.printerName}</option>)}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={3} xs={5}>Label Printer</Label>
                        <Col sm={9} xs={7}>
                            <Input type="select" value={defaultDepotLabelPrinter} onChange={handleDefaultDepotLabelPrinterChange}>
                                {depotPrinters?.map((p, index) => <option key={`p${index}`} value={p.id}>{p.printerName}</option>)}
                            </Input>
                        </Col>
                    </FormGroup>
                </fieldset>
            </Form>
            <div className={styles.buttonGroup}>
                <div>
                    <Button className={styles.btn} color="primary" onClick={saveSettings}>
                        {isSaving ? <div className={styles.spinner}><Spinner size="sm" color="light" /></div> : "Save"}
                    </Button>
                </div>
            </div>
        </React.Fragment>
        );
}

export { UserSettings };